/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Claims_WriteInputs */



/**
* | output |
* | --- |
* | "Approve and reject level claims" |
*
* @param {Perm_Product_Leveling_Claims_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_claims_write = /** @type {((inputs?: Perm_Product_Leveling_Claims_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Claims_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрять и отклонять заявки на уровень")
	return /** @type {LocalizedString} */ ("Approve and reject level claims")
});